import { render, staticRenderFns } from "./DocumentsItem.vue?vue&type=template&id=37c33d96&scoped=true"
import script from "./DocumentsItem.vue?vue&type=script&lang=js"
export * from "./DocumentsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c33d96",
  null
  
)

export default component.exports